import { SEO_TITLE_SIGNUP } from 'mk/autogenerated/translations/SignupPage.2c2b193bf9d09b7f1a53c950aaebc663'
import { analyticsStoreEvent } from 'mk2/actions';
import { UtmQuery } from 'mk2/apps/home/schemas';
import { SIGNUP_FORM_NAME, SignupFormData } from 'mk2/apps/users/components/SignupForm';
import Signup from 'mk2/apps/users/containers/Signup/Signup';
import { signupTrigger } from 'mk2/apps/users/containers/Signup/Signup.actions';
import { cachedInitialValues } from 'mk2/helpers/form';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import Page from 'mk2/pages/Page';
import { AppState, getRequestLastKnownUsername } from 'mk2/reducers';
import { Store } from 'mk2/store/configureStore';
import { parse } from 'query-string';
import * as React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';

interface OwnProps {}

interface StateProps {
    query: UtmQuery;
    initialValues: SignupFormData;
}

interface DispatchProps {
    onSignup(values: SignupFormData, query: UtmQuery, iframe: boolean);
    onStoreEvent(name: string, props: any);
}

type RouteProps = RouteComponentProps<{}>;

export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class SignupPage extends Page<OwnProps & RouteProps, StateProps, DispatchProps> {

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const { location } = ownProps;

            const query = parse(location.search);
            const username = query.username
                ? query.username.toLowerCase()
                : getRequestLastKnownUsername(state);

            return {
                query,
                initialValues: cachedInitialValues(SIGNUP_FORM_NAME, {
                    username: username || '',
                    password: '',
                    email: '',
                    place: '',
                    locationCounty: '',
                    pregnancyState: '',
                    dueDate: '',
                }, username),
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            onSignup: signupTrigger,
            onStoreEvent: analyticsStoreEvent,
        };
    }

    public getMetaTitle(props: Props): string {
        return SEO_TITLE_SIGNUP;
    }

    public render(props: Props): false | JSX.Element {
        return (
            <Signup {...props} />
        );
    }

    public hasPageHeaderPart1(): boolean {
        return false;
    }

    public hasPageHeaderPart2(): boolean {
        return false;
    }

    public hasHeaderBackButton(props: Props): boolean {
        return false;
    }

    public registerInStore(store?: Store<AppState>) {
        return this.loadAndRegisterReducerAndSaga(
            'containers.users.signup',
            null,
            import('mk2/apps/users/containers/Signup/Signup.sagas' /* webpackChunkName: "users.Signup" */),
            store,
        );
    }
}
